<!--
 * @Description: 作业详情公用组件
 * @Author: yangsibo
 * @Date: 2022-06-13 14:54:38
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-06-23 11:03:34
 * @FilePath: \YunYin_admin\src\components\JobQuery\detail.vue
-->

<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="top-info">
        <span class="cell number">
          <i
            class="iconfont icon-dingdanbianhao"
            style="font-size: 20px; margin-right: 5px"
          ></i>
          订单编号：{{ detail.orderNum }}
        </span>
        <span class="cell" v-if="orderCategory == 2"
          >委托方：{{ detail.client }}</span
        >
        <span class="cell" v-if="orderCategory == 3"
          >所属村：{{ detail.villageName }}</span
        >
        <span class="cell">订单类型：{{ detail.orderTypeName }}</span>
      </div>
      <el-table
        class="table-machine-info"
        :data="info"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="cropName"
          label="种植作物"
          min-width="8%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          prop="orderTime"
          label="作业时间要求"
          min-width="15%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          prop="workTypeName"
          label="作业类型"
          min-width="10%"
          align="center"
          :resizable="false"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="trusteeshipArea"
          :label="`${orderCategory == 2 ? '托管' : '流转'}面积（亩）`"
          min-width="12%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          prop="trueWorkArea"
          label="作业面积（亩次）"
          min-width="12%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          prop="trueWorkBeginTime"
          label="作业开始时间"
          min-width="10%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          prop="trueWorkEndTime"
          label="作业结束时间"
          min-width="10%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          label="进度"
          min-width="5%"
          align="center"
          :resizable="false"
        >
          <template slot-scope="scope">
            {{ scope.row.workProgress | formatWorkProgress }}
          </template>
        </el-table-column>
        <el-table-column
          label="作业机手"
          min-width="10%"
          align="center"
          :resizable="false"
        >
          <template slot-scope="scope">{{
            scope.row.workDrivers || "暂无"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="statusName"
          label="作业状态"
          min-width="8%"
          align="center"
          :resizable="false"
        >
        </el-table-column>
      </el-table>
      <LandMap
        v-if="orderCategory == 3"
        :landList="landList"
        :trajectoryList="trajectoryList"
        :mapTopInfoOptions="mapTopInfoOptions"
        :mapRightInfoOptions="mapRightInfoOptions"
        :mapBottomInfoOptions="mapBottomInfoOptions"
      >
        <template v-slot:landInfo="{ landInfo }">
          <MapLandInfoHorizontal
            :curLandInfo="landInfo"
          ></MapLandInfoHorizontal>
        </template>
      </LandMap>
      <LandMap
        v-else
        :landList="landList"
        :trajectoryList="trajectoryList"
        :mapTopInfoOptions="mapTopInfoOptions"
        :mapBottomInfoOptions="mapBottomInfoOptions"
      >
      </LandMap>
    </div>
  </el-main>
</template>

<script>
import LandMap from "@/components/LandMap";
import MapLandInfoHorizontal from "@/components/LandMap/MapLandInfoHorizontal";
export default {
  name: "WorkAssignDetail",
  data() {
    return {
      id: "", // 作业类型ID
      orderId: "", //订单ID
      detail: {}, // 详情上半部分
      info: [], // 详情上半部分-表格内容
      landList: [], // 所有的地块
      trajectoryList: [], // 所有的轨迹块
      // 地图顶部信息配置项
      mapTopInfoOptions: {
        data: [
          { id: 2, name: "未派活", colour: "#ae8b71" },
          { id: 3, name: "已派活", colour: "#ff9600" },
          { id: 5, name: "作业中", colour: "#007eff" },
          { id: 6, name: "作业完成", colour: "#1cba33" },
        ],
      },
      // 地图右部信息配置项
      mapRightInfoOptions: {
        landInfoType: "horizontal", //地块信息样式：vertical 纵向即一行一列，Horizontal横向即一行多列
        hasLandInfoForLandDetail: true, // 地块信息面板是否有地块信息切卡
        hasWorkInfoForLandDetail: true, // 地块信息面板是否有作业信息切卡
        hasAuditInfoForLandDetail: true, // 地块信息面板是否有审核信息切卡
        hasTrajectoryPlayBtn: true, // 是否有轨迹回放按钮
      },
      // 地图底部信息配置项
      mapBottomInfoOptions: {
        hasMapBottomInfo: true, // 是否有底部信息
        orderId: "", // 订单ID
        workTypeId: "", // 作业类型ID
      },
      orderCategory: 2,
    };
  },
  components: {
    LandMap,
    MapLandInfoHorizontal,
  },
  filters: {
    formatWorkProgress(value) {
      let result = `${value}%`;
      return result;
    },
  },
  created() {
    let { id, order_id: orderId, orderCategory } = this.$route.query;
    this.id = id;
    this.orderId = orderId;
    this.mapBottomInfoOptions.orderId = orderId;
    this.mapBottomInfoOptions.workTypeId = id;
    this.orderCategory = orderCategory;
    this.getWorkTypeDetail();
    this.getWorkTypeLandList();
    this.getWorkTypeTrajectory();
  },
  methods: {
    /**
     * @descripttion: 获取订单详情
     * @Author: juanjuanhui
     * @Date: 2021-11-25 10:45:30
     */
    getWorkTypeDetail() {
      this.$http.cooperative.getWorkTypeDetail({ id: this.id }).then((res) => {
        this.isRequest = true;
        this.detail = res.data;
        this.info = [res.data];
      });
    },
    /**
     * @descripttion: 获取地块信息
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:30:34
     */
    getWorkTypeLandList() {
      this.$http.cooperative
        .getWorkTypeLandList({ workTypeId: this.id })
        .then((res) => {
          this.landList = res.data;
        });
    },
    /**
     * @descripttion: 获取轨迹块
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:39:56
     */
    getWorkTypeTrajectory() {
      this.$http.cooperative
        .getWorkTypeTrajectory({ workTypeId: this.id })
        .then((res) => {
          this.trajectoryList = res.data;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.main {
  .top-info {
    display: flex;
    align-items: center;
    padding-top: 10px;
    color: #018388;
    .cell {
      display: flex;
      align-items: center;
      margin-right: 4%;
      &.number {
        font-weight: 900;
      }
    }
  }
  ::v-deep .el-table {
    &.table-machine-info {
      margin-top: 20px;
    }
  }
}
</style>
<style>
.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background: none;
}
</style>
